import React from 'react';
import { InsightProvider } from '../contexts/InsightContext';
import InsightLayout from './InsightLayout';

/**
 * Insight page root component
 *
 * Wraps the insight layout with the shared context provider.
 * All filter state is managed in InsightContext and shared across tabs.
 */
const InsightPage: React.FC = () => {
  return (
    <InsightProvider>
      <InsightLayout />
    </InsightProvider>
  );
};

export default InsightPage;
